// extracted by mini-css-extract-plugin
export default {"required":"UWZ6i5zIEc5RcUdYE948"};